import { render, staticRenderFns } from "./AUsuariosActivos.vue?vue&type=template&id=a796699c"
import script from "./AUsuariosActivos.vue?vue&type=script&lang=js"
export * from "./AUsuariosActivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports